
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[exchange]/[ticker]/holders",
      function () {
        return require("private-next-pages/s/[exchange]/[ticker]/holders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[exchange]/[ticker]/holders"])
      });
    }
  